export default {
    introduce: "Copyright{'@'}2019.All rights reserve.京ICP备19031371号"
}